import { InputNumber, List, Table } from "antd";
import { useEffect, useState } from "react";

const AsignPercent = ({
  selectedEmployees,
  setNecesaryData,
  setAdvanceFlag,
}) => {
  const [employeeWithPercent, setEmployeeWithPercent] = useState(() => {
    return selectedEmployees.map((employee) => ({
      id: employee._id,
      percent: 0,
      calculatedSalary: employee.salary,
    }));
  });

  useEffect(() => {
    const allHavePositivePercent = employeeWithPercent.every(
      (item) => item.percent > 0
    );

    if (allHavePositivePercent) {
      setAdvanceFlag(true);
    } else {
      setAdvanceFlag(false);
    }
    groupEmployees();
  }, [employeeWithPercent]);

  const groupEmployees = () => {
    const groupedEmployees = employeeWithPercent.reduce((groups, employee) => {
      const { percent, calculatedSalary } = employee;
      if (!groups[percent]) {
        groups[percent] = [];
      }
      groups[percent].push({ ...employee, calculatedSalary });
      return groups;
    }, {});
    setGroupedEmployees(groupedEmployees);
    setNecesaryData(groupedEmployees);
  };

  const [groupedEmployees, setGroupedEmployees] = useState({});

  const handleInputChange = (value, index) => {
    setEmployeeWithPercent((prevEmployeeWithPercent) => {
      const updatedEmployeeWithPercent = [...prevEmployeeWithPercent];
      const employee = updatedEmployeeWithPercent[index];
      const salary = selectedEmployees[index].salary;
      const percent = value || 0;

      employee.percent = percent;

      var factorConversion = salary / 100;
      var resultado = factorConversion * percent;

      employee.calculatedSalary = resultado;
      // employee.calculatedSalary = salary * (1 + percent / 100);

      return updatedEmployeeWithPercent;
    });
  };

  const filteredGroupedEmployees = Object.keys(groupedEmployees)
    .filter((percent) => percent > 0)
    .reduce((obj, key) => {
      obj[key] = groupedEmployees[key];
      return obj;
    }, {});

  useEffect(() => {
    const sum = Object.values(groupedEmployees).reduce(
      (acc, employees) =>
        acc +
        employees.reduce(
          (total, employee) =>
            Number(total) + Number(employee.calculatedSalary),
          0
        ),
      0
    );
  }, [groupedEmployees]);

  return (
    <>
      <div>
        <List
          style={{
            maxHeight: "170px",
            overflowY: "auto",
            marginBottom: "10px",
          }}
          itemLayout="horizontal"
          dataSource={selectedEmployees}
          rowKey={"_id"}
          renderItem={(item, index) => (
            <List.Item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div>
                  <span>
                    <strong>{item.name}</strong> - ${" "}
                    {Number(item.salary).toLocaleString("de-DE")}
                  </span>
                </div>
                <InputNumber
                  placeholder="%"
                  value={employeeWithPercent[index]?.percent || ""}
                  onChange={(value) => handleInputChange(value, index)}
                  min={0.01}
                />
              </div>
            </List.Item>
          )}
        />

        {Object.keys(filteredGroupedEmployees).length > 0 && (
          <Table
            style={{
              maxHeight: "200px",
              overflowY: "auto",
              marginBottom: "20px",
            }}
            pagination={false}
            dataSource={Object.keys(filteredGroupedEmployees).map(
              (percent) => ({
                percent,
                totalSalary: filteredGroupedEmployees[percent].reduce(
                  (accumulator, employee) =>
                    // accumulator + employee.calculatedSalary,
                    accumulator + employee.calculatedSalary,
                  0
                ),
              })
            )}
            columns={[
              {
                title: "Porcentaje",
                dataIndex: "percent",
                key: "percent",
                render: (value) => `${value} %`,
              },
              {
                title: "Total Acumulado",
                dataIndex: "totalSalary",
                key: "totalSalary",
                align: "right",
                render: (value) => `$ ${value.toLocaleString("de-DE")}`,
              },
            ]}
          />
        )}
      </div>
    </>
  );
};

export default AsignPercent;
